import { render, staticRenderFns } from "./MyTableBody.vue?vue&type=template&id=1de19a5e"
import script from "./MyTableBody.vue?vue&type=script&lang=js"
export * from "./MyTableBody.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports